import { render, staticRenderFns } from "./ConfirmAddressBanner.vue?vue&type=template&id=3db5bda0&scoped=true&"
import script from "./ConfirmAddressBanner.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddressBanner.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAddressBanner.vue?vue&type=style&index=0&id=3db5bda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db5bda0",
  null
  
)

export default component.exports